/**
 * @file
 * Amélioration UX du menu desktop.
 *
 * IGSTMA-139 Implémente la solution mobile quand la navigation principale
 * devient invisible au scroll pour permettre d'y accéder (sans devoir retourner
 * en haut de la page).
 *
 * @see web/themes/igs/components/layout/headermobile/_headermobile.scss
 */

(function (Drupal, $, once) {
  Drupal.behaviors.desktopMenuBurger = {
    attach: function (context, settings) {
      $(once('desktopMenuBurger', '#block-navigationprincipale', context)).each(function () {
        var $main_menu = $('#block-navigationprincipale', context);
        var $burger_btn = $('.HeaderMobile-menu', context);
        var observer = new IntersectionObserver(

          /**
           * IntersectionObserver "observe" callback.
           */
          function(IntersectionObserverEntries) {
            IntersectionObserverEntry = IntersectionObserverEntries[0];
            if (IntersectionObserverEntry.isIntersecting) {
              $burger_btn.removeClass('js-on').addClass('js-off');
            }
            else {
              $burger_btn.removeClass('js-off').addClass('js-on');
            }
          }
        );

        observer.observe($main_menu.get(0));
      });
    }
  };
})(Drupal, jQuery, once);
